import { API_ORIGIN } from '../config'
const API_BASE = `${API_ORIGIN}/api`

export async function getParks() {
  const response = await fetch(`${API_BASE}/parks`)
  if (!response.ok) throw new Error('Error al obtener parques')
  return response.json()
}

export async function getParkById(id) {
  const response = await fetch(`${API_BASE}/parks/${id}`)
  if (!response.ok) throw new Error('Error al obtener el parque')
  return response.json()
}

export async function getParkKpis(id) {
  const response = await fetch(`${API_BASE}/parks/${id}/kpis`)
  if (!response.ok) throw new Error('Error al obtener los KPIs')
  return response.json()
}

export async function getExpiringContracts(parkId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/contracts/expiring`)
  if (!response.ok) throw new Error('Error al obtener contratos por vencer')
  return response.json()
}

export async function getOccupancyHistory(parkId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/occupancy-history`)
  if (!response.ok) throw new Error('Error al obtener historial de ocupación')
  return response.json()
}

export async function getFinancePeriods(parkId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/finance/periods`)
  if (!response.ok) throw new Error('Error al obtener los periodos')
  return response.json()
}

export async function getFinanceSummary(parkId, period, comparisonPeriod) {
  const params = new URLSearchParams({ period })
  if (comparisonPeriod) params.set('comparisonPeriod', comparisonPeriod)
  const response = await fetch(`${API_BASE}/parks/${parkId}/finance/summary?${params}`)
  if (!response.ok) throw new Error('Error al obtener el resumen financiero')
  return response.json()
}

export async function getFinanceHistory(parkId, period, comparisonPeriod, monthsCount) {
  const params = new URLSearchParams({ period })
  if (comparisonPeriod) params.set('comparisonPeriod', comparisonPeriod)
  if (monthsCount) params.set('months', monthsCount)
  const response = await fetch(`${API_BASE}/parks/${parkId}/finance/history?${params}`)
  if (!response.ok) throw new Error('Error al obtener el historial financiero')
  return response.json()
}

export async function getFinanceProjection(parkId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/finance/projection`)
  if (!response.ok) throw new Error('Error al obtener la proyección de ingresos')
  return response.json()
}